import { Tooltip } from "@heroui/react";
import internalNoteImg from "../../icon-internal_note.png";

interface InternalNoteIndicatorProps {
  note: string;
  t: (key: string) => string;
}

export function InternalNoteIndicator({ note, t }: Readonly<InternalNoteIndicatorProps>) {
  return (
    <Tooltip
      content={
        <div className="px-1 py-2">
          <div className="text-small w-96">{note}</div>
        </div>
      }
    >
      <img src={internalNoteImg} className="w-6 h-6 ml-1" alt={t("internal_note_icon")} />
    </Tooltip>
  );
};

export default InternalNoteIndicator;
